import { useContext } from 'react';
import { AuthContext } from './AuthProvider.js';

export function useAuth() {
  return useContext(AuthContext);
}
